import { useCallback, useEffect, useRef, useState } from 'react';

import { readDraft, writeDraft } from './utils';

const useChatDraft = chatId => {
  const [draft, setDraftState] = useState(() => readDraft(chatId));
  const currentChatIdRef = useRef(chatId);

  const setDraft = useCallback(
    value => {
      setDraftState(value);
      writeDraft(chatId, value);
    },
    [chatId],
  );

  const clearDraft = useCallback(() => {
    setDraftState('');
    writeDraft(chatId, '');
  }, [chatId]);

  useEffect(() => {
    if (currentChatIdRef.current === chatId) {
      return;
    }

    currentChatIdRef.current = chatId;
    setDraftState(readDraft(chatId));
  }, [chatId]);

  return { draft, setDraft, clearDraft };
};

export default useChatDraft;
